import React, { useState } from "react";
import AuthShell from "../components/auth/AuthShell";
import { authService } from "../services/authService";

/**
 * Şifremi unuttum — adres kayıtlı olsun ya da olmasın AYNI onay ekranı gösterilir.
 * Sunucu da aynı yanıtı döndürür; bu ekran kullanıcı listesi keşfetmek için
 * kullanılamaz.
 */
const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const value = email.trim();
    if (!value) return setError("E-posta adresinizi giriniz.");

    setLoading(true);
    setError("");
    try {
      await authService.forgotPassword(value);
      setSent(true);
    } catch (err: any) {
      const data = err?.response?.data;
      setError(
        data?.message ||
          "İstek gönderilemedi. Bağlantınızı kontrol edip yeniden deneyin.",
      );
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthShell
        title="Postanızı kontrol edin"
        backTo={{ to: "/login", label: "Giriş ekranına dön" }}
      >
        <div className="lg-notice ok" role="status">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 6h16v12H4z" />
            <path d="m4 7 8 6 8-6" />
          </svg>
          <div>
            <strong>{email}</strong> adresi kayıtlıysa şifre sıfırlama bağlantısı
            gönderildi.
            <p>
              Bağlantı <b>60 dakika</b> geçerlidir ve yalnızca bir kez
              kullanılabilir. Postayı göremiyorsanız gereksiz/spam klasörüne bakın.
            </p>
          </div>
        </div>

        <button
          type="button"
          className="lg-submit ghost"
          onClick={() => { setSent(false); setError(""); }}
        >
          Farklı bir adres dene
        </button>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="Şifremi Unuttum"
      subtitle="Hesabınızın e-posta adresini girin, sıfırlama bağlantısı gönderelim"
      backTo={{ to: "/login", label: "Giriş ekranına dön" }}
    >
      <form onSubmit={submit} className="lg-form" noValidate>
        {error && (
          <div className="lg-error" role="alert">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 8v4M12 16h.01" />
            </svg>
            <span>{error}</span>
          </div>
        )}

        <div className="lg-field">
          <label htmlFor="email">E-posta Adresi</label>
          <input
            id="email"
            type="email"
            placeholder="ad.soyad@sirketiniz.com"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setError(""); }}
            autoComplete="email"
            autoFocus
            required
          />
        </div>

        <button type="submit" className="lg-submit" disabled={loading}>
          {loading ? (
            <>
              <span className="lg-spinner" aria-hidden="true"></span>
              Gönderiliyor…
            </>
          ) : (
            "Sıfırlama Bağlantısı Gönder"
          )}
        </button>
      </form>
    </AuthShell>
  );
};

export default ForgotPassword;
